import { render, staticRenderFns } from "./blessingDragon.vue?vue&type=template&id=67e56422"
import script from "./blessingDragon.vue?vue&type=script&lang=js"
export * from "./blessingDragon.vue?vue&type=script&lang=js"
import style0 from "./blessingDragon.vue?vue&type=style&index=0&id=67e56422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports